import styled from '@emotion/styled';

export const CustomFooter = styled.footer`
clear:both;
display: flex;
  width: 100%;
  padding: 5px 15px;
  background-color: #202020;

`;

export const FooterText = styled.p`
  text-align: left;
  color: #f0e7e7;
  font-size: 14px;
  font-weight: 600;
  padding: 5px 15px;
  margin: 0;
`;